import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import Bandeau from 'brastrap/common/bandeau/Bandeau';
import Welcome from 'brastrap/editorial/welcome/Welcome';
import Shop from 'brastrap/editorial/shop/Shop';
import Container from 'brastrap/common/container/Container';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';

const messages = defineMessages({
  shopInfo: {
    id: 'shops-section.shop-information',
    defaultMessage: 'Shop information',
  },
  title: { id: 'shops-section.title', defaultMessage: 'All shops' },
});

const ShopContainer = props => {
  const {
    intl: { formatMessage },
  } = props;

  const returnNav = {
    label: formatMessage(messages.title),
    url: '/shops/all/',
  };

  const shopInformationTitle = formatMessage(messages.shopInfo);

  return (
    <div className="c-shop-container">
      <Bandeau
        className="c-shop-container__title"
        title={props.name}
        returnNav={returnNav}
      />

      <Welcome
        title={props.title}
        main={props.introduction}
        images={props.welcomeImages.map(({ url, label }) => ({
          src: url,
          alt: label,
        }))}
      />
      {props.containers && <EditorialContainer containers={props.containers} />}

      <Container title={shopInformationTitle} modifiers={['offset']}>
        <Shop {...props} />
      </Container>
    </div>
  );
};

ShopContainer.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  introduction: PropTypes.string,
  welcomeImages: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ),
  containers: PropTypes.array,
  ...Shop.propTypes,
  intl: intlShape,
};

ShopContainer.defaultProps = {
  welcomeImages: [],
  ...Shop.defaultProps,
};

export default injectIntl(ShopContainer);
